import { PageHeaderWrapper, Button } from 'cdk-radial';
import styled from 'styled-components';

export const StyledPageHeaderWrapper = styled(PageHeaderWrapper)`
  flex: none;
  border-bottom: ${({ theme }) => `1px solid ${theme.color.gray[200].value}`};
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  padding: 12px 16px 12px 0;
  margin-left: auto;
`;

export const StyledButton = styled(Button)`
  margin-left: 8px;
`;
